import React from 'react';
import { useNavigate } from "react-router-dom"
import { Auth, logUserActivity, Toast, UserActivity } from "../../services"
import Form from "react-bootstrap/Form"
import InputGroup from "react-bootstrap/InputGroup"
import * as formik from "formik"
import * as yup from "yup"
import { FaUser, FaLock } from "react-icons/fa"
import { config, errorList } from "../../core/constants"

const UserIcon = FaUser as React.FC<{ className?: string }>
const LockIcon = FaLock as React.FC<{ className?: string }>

const Login = () => {
  Auth.logout();
  const navigate = useNavigate();
  const { Formik } = formik;

  const LoginSchema = yup.object().shape({
    username: yup
      .string()
      .email("Please enter valid email address")
      .required("Email is required"),
    password: yup.string().required("Password is required"),
  })

  const error = (status: number, message?: string) => {
    if (
      status === 504 ||
      status === 503 ||
      status === 502 ||
      status === 500 ||
      status === 404 ||
      status === 403 ||
      status === 401 ||
      status === 400
    ) {
      Toast(message || errorList.get(status), "error")
    }
  }

  const submit = async (values: any) => {
    Auth.login(values).then(
      (res: any) => {
        if (res.status === 200 || res.status === 204) {
          const navItems = Auth.privilegeItems();
          navigate(navItems[0]?.href);
          let userActivity: UserActivity = {
            action: 'Logged In',
            page: 'Landing',
            viewName: navItems[0]?.text
          }
          logUserActivity(userActivity);
        } else {
          error(res.status, res.message)
        }
      },
      (err: any) => {
        error(err.response?.status || 503, err.response?.statusText)
      },
    )
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-4 col-md-8 offset-lg-4 offset-md-2 mt-70">
          <div
            className="panel border bg-white p-4 mt-4"
            style={{ boxShadow: "0 0.75rem 1.5rem 0 rgba(0, 0, 0, 0.1)" }}
          >
            <div className="panel-heading text-center">
              <div className="navbar-brand my-4" style={{ lineHeight: "1.2" }}>
                <img
                  src="https://cdn.wolterskluwer.io/wk/fundamentals/2.x.x/logo/assets/wheel-large.svg"
                  alt="Wolters Kluwer"
                  className="wk-logo wk-logo-medium"
                /> <span className="wk-size-7 pl-2">SoS Intel</span>
              </div>
            </div>
            <div className="panel-body p-2 text=center">
              <Formik
                validationSchema={LoginSchema}
                initialValues={{ username: "", password: "" }}
                onSubmit={submit}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isValid,
                  dirty,
                }) => (
                  <Form
                    noValidate
                    onSubmit={handleSubmit}
                    data-testid="login-form"
                  >
                    <Form.Group className="mb-4 mt-2" controlId="validationUsername">
                      <InputGroup hasValidation>
                        <InputGroup.Text id="inputGroupPrepend">
                          <UserIcon className="wk-primary-blue" />
                        </InputGroup.Text>
                        <Form.Control
                          type="text"
                          placeholder="Enter username"
                          aria-describedby="inputGroupPrepend"
                          name="username"
                          value={values.username}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={!!errors.username}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.username && touched.username}
                        </Form.Control.Feedback>
                      </InputGroup>
                    </Form.Group>

                    <Form.Group className="mb-4" controlId="validationPassword">
                      <InputGroup hasValidation>
                        <InputGroup.Text id="inputGroupPrepend">
                          <LockIcon className="wk-primary-blue" />
                        </InputGroup.Text>
                        <Form.Control
                          type="password"
                          placeholder="Password"
                          aria-describedby="inputGroupPrepend"
                          name="password"
                          value={values.password}
                          onChange={handleChange}
                          isInvalid={!!errors.password}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.password && touched.password}
                        </Form.Control.Feedback>
                      </InputGroup>
                    </Form.Group>
                    <div className="text-center">
                      <button
                        data-testid="button"
                        type="submit"
                        className="w-100 wk-button border-round"
                        disabled={!(dirty && isValid)}
                      >
                        Login
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
              <div className="text-center mt-3" style={{ fontSize: "11px" }}>
                Powered by <strong style={{ color: "#007ac3" }}>Digital Twin</strong>
              </div>
            </div>
          </div>
          <div className="mt-4 text-center wk-footer-copyright-info wk-footer-copyright-info-workflow">
            © {config.copyright} Wolters Kluwer. All rights reserved.
          </div>
        </div>
      </div>
    </div>
  )
}

export default Login
